
<router-outlet></router-outlet>
<ngx-ui-loader fgsColor="#c12228" pbColor="#c12228"></ngx-ui-loader>
